export default "__VITE_ASSET__7bfc328f__"